"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ImageBlock = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useRecommendationGallery = require("../../../../hooks/recommendation/useRecommendationGallery");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ImageWrapper = _styledComponents.default.div`
  display: flex;
  justify-content: center;
`;
const ImageBlock = _ref => {
  let {
    img,
    handsetIndex,
    index
  } = _ref;
  const defaultAltAttribute = index ? `product-image-${handsetIndex}-${index}` : `product-image-${handsetIndex}`;
  return /*#__PURE__*/_react.default.createElement(ImageWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Image, {
    alt: (img === null || img === void 0 ? void 0 : img.alt) || defaultAltAttribute,
    sm: {
      src: img === null || img === void 0 ? void 0 : img.src,
      width: 'auto',
      height: '250px'
    },
    dataAttributes: {
      'data-test-id': `device-images-${index}-${handsetIndex}`
    }
  }));
};
exports.ImageBlock = ImageBlock;
const GalleryContainer = _styledComponents.default.div`
  display: flex;
  justify-content: center;
`;
const MediaGallery = _ref2 => {
  var _galleryImages$;
  let {
    media,
    handsetIndex
  } = _ref2;
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const {
    galleryImages
  } = (0, _useRecommendationGallery.useRecommendationGallery)(media);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, galleryImages && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, breakpoints.sm && {
    justify: 'center'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, galleryImages.length === 1 ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(ImageBlock, {
    img: galleryImages[0],
    handsetIndex: handsetIndex
  })) : /*#__PURE__*/_react.default.createElement(GalleryContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Gallery, {
    maxWidth: "200px",
    thumbs: galleryImages,
    transitionSpeed: 600,
    key: (_galleryImages$ = galleryImages[0]) === null || _galleryImages$ === void 0 ? void 0 : _galleryImages$.id
  }, galleryImages.map((img, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: `image${img.id}`
  }, /*#__PURE__*/_react.default.createElement(ImageBlock, {
    img: img,
    handsetIndex: handsetIndex,
    index: index
  }))))))));
};
var _default = MediaGallery;
exports.default = _default;